import $api from '@/http/api'
import $common from '../common'

export default {
	namespaced: true,
	state: {
		servicePackDetail: {},
		serviceChild: {} // 正在进行预约操作的服务项信息
	},
	getters: {
		getDetail: state => $common.storeGetterSessionCommon(state, 'servicePackDetail', 'object'),
		getServiceChild: state => $common.storeGetterSessionCommon(state, 'serviceChild', 'object')
	},
	mutations: {
		['SET_SERVICE_PACK_DETAIL'](state, val) {
			state.servicePackDetail = val
			window.sessionStorage.setItem('servicePackDetail', JSON.stringify(val))
		},
		['SET_SERVICE_CHILD'](state, val) {
			state.serviceChild = val
			window.sessionStorage.setItem('serviceChild', JSON.stringify(val))
		}
	},
	actions: {
		/**
		 * @method 获取详情
		 * @params { string } id 服务id
		 * @params { cb } 回调方法
		 */
		async apiGetServiceDetail({ commit }, { params, cb }) {
			let func = $api.servicePack.getDetail
			if (params && params.type === 'doctor') {
				func = $api.servicePack.getDetailByDoctor
			}
			if (params && params.type === 'serviceRecord') {
				func = $api.servicePack.getPakRecordInfo
			}
			const res = await func(params)

			if (!res.code) {
				let data = res.data
				// if(params&&params.type === 'doctor'){
				// 	data.serviceInfo = res.data.pkgInfo
				// 	data.name = res.data.title
				// }
				console.log(data)
				commit('SET_SERVICE_PACK_DETAIL', data)
				cb && cb(data)
			}
		}
	}
}
